import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { CockpitResponseModel } from '@/types'

export const getCockpitMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<CockpitResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/cockpit`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
